import React from "react";
import styled from "styled-components"

const BackgroundImage = styled.div`
    min-height: 100vh
    background: url('https://easygestor.com/wp-content/uploads/2023/02/fundo-easygestor-2023.png');
    background-repeat: no-repeat
    background-size: cover
    background-position: center
    padding-top: 30px
    padding-bottom: 30px
    image-resolution: from-image;

    @media (max-width: 600px){
        background: white;
    }
`
export default BackgroundImage


// WEBPACK FOOTER //
// ./src/views/Auth/components/BackgroundImage/index.jsx